export const EnrollProgressBarInitialiseAction = 'enroll-progress-bar-initialise';
export const EnrollProgressBarNextQuestionAction = 'enroll-progress-bar-next-question';
export const EnrollProgressBarBackQuestionAction = 'enroll-progress-bar-back-question';
export const EnrollProgressBarNextSectionAction = 'enroll-progress-bar-next-section';
export const EnrollProgressBarBackSectionAction = 'enroll-progress-bar-back-section';
